import { createContext, useContext } from 'react';
import { useSelect } from '../hooks';

export const SelectContext = createContext<ReturnType<typeof useSelect> | null>(
  null
);

export const useSelectContext = () => {
  const ctx = useContext(SelectContext);

  if (!ctx) {
    throw new Error('useSelectContext must be used inside Select');
  }

  return ctx;
};
